<template>
  <div class="login-page-wrapper">
    <div class="log-wrapper">
      <img src="../../assets/img/logo.svg" alt="">
    </div>
    <div class="form-wrapper">
      <n-input v-model="user.email"
        :validate="ers.email"
        :placeholder="masLang[0]"
        type="email"
        class="nerz-input-unauth input floating-placeholder-unauth placeholder-unauth"
        @chargeRifleInput="nullCheckVal"
      >
      </n-input>
      <n-input v-model="user.name"
        :validate="ers.name"
        :placeholder="masLang[1]"
        type="text"
        class="nerz-input-unauth input floating-placeholder-unauth placeholder-unauth"
        @chargeRifleInput="nullCheckVal"
      >
      </n-input>
      <n-input v-model="user.screen_name"
        :validate="ers.screen_name"
        :placeholder="masLang[2]"
        type="text"
        class="nerz-input-unauth input floating-placeholder-unauth placeholder-unauth"
        @chargeRifleInput="nullCheckVal"
      >
      </n-input>
      <div class="select-wrapper">
        <select class="select" :class="user.country == '' ? 'not-selected' : ''  "  v-model="user.country" @change="nullCheckVal">
          <option value='' disabled selected style='display:none;'>{{masLang[3]}}</option>
          <option v-for="(val, key) in countryMaster" :value="val.companyen">{{ val.companyen }}</option>
        </select>
      </div>
      <n-input v-model="user.password"
        :validate="ers.password"
        :placeholder="masLang[4]"
        type="password"
        class="nerz-input-unauth input floating-placeholder-unauth placeholder-unauth"
        @chargeRifleInput="nullCheckVal"
      >
      </n-input>
      <n-input v-model="user.password2"
        :validate="ers.password2"
        :placeholder="masLang[5]"
        type="password"
        class="nerz-input-unauth input floating-placeholder-unauth placeholder-unauth"
        @chargeRifleInput="nullCheckVal"
      >
      </n-input>
      <div class="terms-check">
        <input
        v-model="termsCheck"
        type="checkbox"
        class="center"
        value="true"
        @change="nullCheckVal"
        >
        <p>
        &nbsp;<a href="/terms-of-service">{{masLang[6]}}</a> , <a href="/privacy-policy">{{masLang[7]}}</a>{{masLang[8]}}
        </p>
      </div>
      <div class="btn-wrapper">
        <btn :label="masLang[9]" type="white" size="normal" @click="back()"></btn>
        <btn class="sign_up" :label="masLang[10]" type="disabled" size="normal" v-if="!isSend"></btn>
        <btn class="sign_up" :label="masLang[10]" type="primary" size="normal" @click="register()" :loading="loading" v-else></btn>
      </div>
    </div>
    <div class="login-back">
      <img src="../../assets/img/nazuna-top.png" class="nazuna-img" alt="">
    </div>
    <notice v-if="isNotice" :title="noticeTitle" :text="noticeText" :type="noticeType"></notice>
  </div>
</template>

<script>

import btn from '../../components/Button.vue';
import notice from '../../components/Notice.vue';
import axios from 'axios';
import NInput from '../../components/Input.vue'
import NSelect from '../../components/Select.vue'
import errHandling from '../../mixins/apiErrorHandle.js'
import SignUpLangMaster from '../../masters/langMaster/SignUpLangMaster.js'
import CountryMaster from '../../masters/countryMaster.js'

export default {
  name: 'RegisterIndex',

  components: {
    btn,
    notice,
    NInput,
    NSelect,
  },

  mixins: [errHandling],

  data() {
    return {
      masLang: '',
      countryMaster: [],
      isSend: false,
      user: {
        email: '',
        name: '',
        screen_name: '',
        password: '',
        password2: '',
        country: '',
        lang: '',
      },
      ers: {
        email: '',
        name: '',
        screen_name: '',
        password: '',
        password2: '',
      },
      isNotice: false,
      noticeText: '',
      noticeTitle: '',
      noticeType: '',
      loading: false,
      termsCheck: false,
      langGet: '',
    };
  },

  created(){
    this.countryMaster = CountryMaster
    this.langGet = navigator.language
    if(this.langGet === "ja") {
     this.masLang = SignUpLangMaster['ja'];
     this.user.country = 'Japan'
    } else {
     this.masLang = SignUpLangMaster['en'];
    }
  },

  methods: {
    register() {
      this.loading = true
      if(this.user.country === "Japan") {
        this.user.lang = 'ja'
      } else {
        this.user.lang = 'en'
      }
      axios.post('public/register', this.user).then(data => {
        this.$router.push({ name: 'register.thx' })
      }).catch(err => {
        this.loading = false
        this.errorHandling(err)
      });
    },

    back() {
      this.$router.push('/login')
    },

    nullCheckVal() {
      let checkArr = ['email','name','screen_name','password','password2', 'country']
      console.log(this.user.country);
      for(let i=0, len=checkArr.length; i < len; i++) {
        if(!this.user[checkArr[i]]) {
          this.isSend = false
          return false
        } else if(this.user.password != this.user.password2){
          this.isSend = false
          return false
        } else if(this.termsCheck != true){
          this.isSend = false
          return false
        }else {
          this.isSend = true
        }
      }
    }
  },
};

</script>

<style scoped>
.login-page-wrapper{
  min-height: 100vh;
  height: 100%;
  position: relative;
}

.login-back {
  background: #F39939;
  filter: blur(10px) saturate(70%);
  position: absolute;
  z-index: -1;
  width: 100vw;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
}

.log-wrapper {
  width: 98%;
  max-width: 500px;
  margin: auto;
  padding-top: 15%;
}

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.log-wrapper img {
  width: 100%;
}

.form-wrapper {
  width: 98%;
  position: static;
  top: 50%;
  left: 50%;
  transform: translate(0, 0);
}

.btn-wrapper {
  display: flex;
  justify-content: space-around;
  padding-bottom: 15%;
}

.btn-wrapper button {
  margin: 10px;
}

.input {
  appearance: none;
  border: none;
  border-bottom: 1px solid #fff;
  color: #fff;
  font-size: 15px;
  background: transparent!important;
  display: block;
  width: 90%;
  margin: 5% auto;
}

::placeholder{
  opacity: 0.5;
}

input::placeholder {
  color: #fff;
}

.form-wrapper input:-internal-autofill-selected {
  color: #fff;
}

.nazuna-img {
  position: absolute;
  bottom: 0%;
  right: -20%;
  width: 70%;
}

input:-webkit-autofill {
  /* ここで指定しているbackground-colorは黄色い背景色のことです */
  -webkit-transition: 9999s;
  transition: 9999s;
}

.select {
  border: none;
  border-bottom: 1px solid #fff;
  background: transparent;
  padding: 3px 0;
  font-size: 14px;
  width: 100%;
}

.select-wrapper {
  margin: 5%;
  width: 90%;
  position: relative;
}

.select-wrapper::after {
  display: block;
  content: "";
  position: absolute;
  right: 3%;
  top: 40%;
  width: 30px;
  height: 30px;
  border-right: 15px solid transparent;
  border-top: 10px solid #fff;
  border-left: 15px solid transparent;
}

.not-selected {
  color: #000;
}

.nerz-input-unauth >>> .nerz-input {
  width: 100%;
  margin: auto;
  line-height: 1;
  padding: 10px 5px;
  font-size: 16px;
  appearance: none;
  border: none;
  background: transparent!important;
  padding-top: 0;
  color: white;
}

.floating-placeholder-unauth >>> .floating-placeholder {
  font-size: 12px;
  line-height: 0;
  margin-block-end: 0px;
  margin-bottom: 5px!important;
  margin-left: 5px;
  color: white;
  font-weight: bold;
}

.placeholder-unauth ::placeholder {
  font-size: 14px;
  color: #ffffff5c;
}

.terms-check{
  display: flex;
  justify-content: center;
  margin: 5px;
  font-size: 14px;
  color: #000000;
}

.terms-check p{
  display: inline-block;
  vertical-align: middle;
}

@media screen and (min-width: 600px){

  .log-wrapper {
    margin-left: 10%;
    padding-top: 5%;
  }

  .form-wrapper{
    position: absolute;
    transform: translate(-50%, -65%);
    width:50%;
    left:33%;
    bottom:5%;
  }

  .btn-wrapper{
    justify-content: center;
    padding: 0;
  }

  .sign_up {
    margin-left: 5%;
  }

}
</style>
